export default "assets/images/icons/arrow-white-circle-brown-d6c17bbe.svg";